@let iconValue = icon();
@let position = iconPosition();
@let visibleLabel = label() && !visuallyHiddenLabel();
<button
    [type]="buttonType()"
    [class]="buttonClasses()"
    [disabled]="disabled()"
    [attr.aria-labelledby]="titleId() ?? ''"
    [attr.title]="buttonTitle()"
>
    @if (iconValue && position === 'left') {
    <fa-icon
        [icon]="iconValue"
        [class]="`fa-${size()} ${visibleLabel ? 'me-2' : ''}`"
        aria-hidden="true"
        focusable="false"
    />
    }
    <span [class.visually-hidden]="!visibleLabel" i18n>{{ label() }}</span>
    @if (iconValue && position === 'right') {
    <fa-icon
        [icon]="iconValue"
        [class]="`fa-${size()} ${visibleLabel ? 'ms-2' : ''}`"
        aria-hidden="true"
        focusable="false"
    />
    }
</button>
@if (titleId()) {
<span class="visually-hidden" id="{{ titleId() }}">{{ buttonTitle() }}</span>
}
